module.exports = __webpack_public_path__ + "images/mobile/stars/todo-c84529fdb0b127950cff992963a40f60.png";